var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.832 21.8009C15.958 21.1749 20 18.9259 20 13.1109C20 7.81993 16.127 4.29593 13.342 2.67693C12.723 2.31693 12 2.78993 12 3.50493V5.33293C12 6.77493 11.394 9.40693 9.71 10.5019C8.85 11.0609 7.92 10.2239 7.816 9.20393L7.73 8.36593C7.63 7.39193 6.638 6.80093 5.86 7.39493C4.461 8.45993 3 10.3299 3 13.1099C3 20.2209 8.289 21.9999 10.933 21.9999C11.0877 21.9999 11.249 21.9949 11.417 21.9849C10.111 21.8739 8 21.0639 8 18.4439C8 16.3939 9.495 15.0089 10.631 14.3339C10.937 14.1539 11.294 14.3889 11.294 14.7439V15.3339C11.294 15.7839 11.469 16.4889 11.884 16.9709C12.354 17.5169 13.043 16.9449 13.098 16.2269C13.116 16.0009 13.344 15.8569 13.54 15.9709C14.181 16.3459 15 17.1459 15 18.4439C15 20.4919 13.871 21.4339 12.832 21.8009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFire);
export default __webpack_public_path__ + "static/media/ic_fire.948068de7e61bbfd63bbd50b659d8897.svg";
export { ForwardRef as ReactComponent };